// import { useEffect } from 'react';
// import { supabase } from './supabaseClient';  // Your Supabase client
// import { useNavigate } from 'react-router-dom';

// const CompleteSignup = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const handleAuthRedirect = async () => {
//       const url = new URL(window.location.href);
//       const accessToken = url.hash.match(/access_token=([^&]*)/)?.[1]; // Extract the access_token from the URL
//       const refreshToken = url.hash.match(/refresh_token=([^&]*)/)?.[1];

//       if (accessToken && refreshToken) {
//         // Use Supabase's setSession function to restore the session with the tokens
//         const { error } = await supabase.auth.setSession({
//           access_token: accessToken,
//           refresh_token: refreshToken
//         });

//         if (error) {
//           console.error('Error setting session:', error.message);
//         } else {
//           // Fetch user and redirect based on role
//           const { data: user, error: fetchError } = await supabase.auth.getUser();

//           if (fetchError) {
//             console.error('Error fetching user:', fetchError.message);
//           } else if (user) {
//             console.log(user)
//             const role = user.user_metadata?.role;

//             // Redirect based on role
//             if (role === 'lawyer') {
//               navigate('/basicinfo-lawyer');
//             } else if (role === 'admin') {
//               navigate('/inviteteam');
//             } else {
//               console.error('Unknown role:', role);
//             }
//           }
//         }
//       } else {
//         console.error('Access token missing from URL');
//       }
//     };

//     handleAuthRedirect();
//   }, [navigate]);

//   return <div>Redirecting...</div>;
// };

// export default CompleteSignup;

import { useEffect } from "react";
import { supabase } from "./supabaseClient"; // Your Supabase client
import { useNavigate } from "react-router-dom";

const CompleteSignup = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthRedirect = async () => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.hash.substring(1)); // Remove the leading "#" and parse

      const accessToken = params.get("access_token");
      const refreshToken = params.get("refresh_token");

      console.log("Access Token:", accessToken);
      console.log("Refresh Token:", refreshToken);

      if (accessToken && refreshToken) {
        // Use Supabase's setSession function to restore the session with the tokens
        const { error: sessionError } = await supabase.auth.setSession({
          access_token: accessToken,
          refresh_token: refreshToken,
        });

        if (sessionError) {
          console.error("Error setting session:", sessionError.message);
        } else {
          // Fetch user data from Supabase
          const {
            data: { user },
            error: fetchError,
          } = await supabase.auth.getUser();

          if (fetchError) {
            console.error("Error fetching user:", fetchError.message);
          } else if (user) {
            console.log("User data:", user); // Log the full user object
            const role = user.user_metadata?.role; // Access user metadata for role

            if (role) {
              console.log("Role:", role); // Log the role
              // Redirect based on role
              if (role === "lawyer") {
                navigate("/basic-details-lawyer");
              } else if (role === "client") {
                const pending = user.user_metadata?.pendingAppointment;
                if (pending && pending.lawyerId) {
                  // direct them to the payment page
                  const qs = new URLSearchParams(pending).toString();
                  console.log("adding query string:", qs);
                  navigate(`/createuser/details?${qs}`);
                } else {
                  // no appointment flow → regular onboarding
                  navigate("/createuser/details");
                }
              } else if (role === "attorney") {
                navigate("/grow/login");
              } else {
                console.error("Unknown role:", role);
              }
            } else {
              console.error("Role not found in user metadata");
            }
          }
        }
      } else {
        console.error("Access token or refresh token missing from URL");
      }
    };

    handleAuthRedirect();
  }, [navigate]);

  return <div>Redirecting...</div>;
};

export default CompleteSignup;
